package com.downdogapp.client.singleton

actual object FileSystemHelper : FileSystemHelperInterface {

  override fun createDirectory(path: String) {
    throw UnsupportedOperationException("No filesystem exists for JS implementation")
  }

  override fun listDirectoryContents(path: String): List<String> {
    throw UnsupportedOperationException("No filesystem exists for JS implementation")
  }

  override fun removeFile(path: String) {
    throw UnsupportedOperationException("No filesystem exists for JS implementation")
  }

  override fun getFileSize(path: String): Long {
    throw UnsupportedOperationException("No filesystem exists for JS implementation")
  }

  override fun downloadToFile(url: String,
                              destinationPath: String,
                              onComplete: (String, Error?) -> Unit): Long {
    throw UnsupportedOperationException("No filesystem exists for JS implementation")
  }

  override fun getDownloadTask(downloadId: Long): DownloadTask? {
    throw UnsupportedOperationException("No filesystem exists for JS implementation")
  }

  override fun cancelDownload(downloadId: Long) {
    throw UnsupportedOperationException("No filesystem exists for JS implementation")
  }
}

actual class DownloadTask(actual val url: String,
                          actual val destinationPath: String,
                          actual val onComplete: (String, Error?) -> Unit) {

  actual fun getProgressProportion(): Double {
    throw UnsupportedOperationException("No filesystem exists for JS implementation")
  }
}
